/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { fetchRaydiumPools, RaydiumPool } from '../../lib/solana/raydium';

export const raydiumApi = {
    /**
     * Fetch all mainnet pools
     */
    getPools: async (): Promise<RaydiumPool[]> => {
        return await fetchRaydiumPools();
    },

    /**
     * Get specific pool statistics
     */
    getPoolStats: async (pairAddress: string) => {
        // Mock specific stat lookup
        await new Promise(r => setTimeout(r, 200));
        return {
            volume24h: Math.random() * 1000000,
            tvl: Math.random() * 5000000,
            apr24h: Math.random() * 15,
            price: Math.random() * 10
        };
    }
};